<template>
  <a :href="href" target="_blank" rel="noreferrer" aria-label="`visit ${title} in a new tab`">
    <article class="g-project">
      <img
        :src="require(`../assets/images/${imgName}`)"
        :alt="`${alt}`"
        :aria-describedby="`${title.replace(' ', '-')}-project`"
      />
      <div class="g-info">
        <span class="g-title">{{ title }}</span>
        <span :id="`${title.replace(' ', '-')}-project`" class="g-description body-2">{{ description }}</span>
        <a :href="href" target="_blank" rel="noreferrer" class="g-link" tabindex="-1" aria-label="`visit ${title} in a new tab`">{{ "View Project Showcase" }}</a>
      </div>
    </article>
  </a>
</template>

<script>
  export default {
    name: "Project",
    props: {
      href: String,
      title: String,
      imgName: String,
      description: String,
      alt: String
    },
  };
</script>

<style lang="scss" scoped>
  @import "../variables";

  .g-project {
    background: $gskinner-gray-1;
    box-shadow: 0px -2px 10px 0px rgba(33, 35, 43, 0.2);
    border-radius: pxToRem(8);
    overflow: hidden;
    margin: 1.5%;
    width: 42%;
    display: inline-block;
    transition: 1s;
    @media (prefers-reduced-motion) {
      transition: 2s;
    }
    @media (max-width: $m-width) {
      width: 60%;
    }
    @media (max-width: $s-width) {
      width: 80%;
      margin: 2%;
    }

    &:hover {
      transform: scale(1.06);
      @media (prefers-reduced-motion) {
        transform: scale(1.01);
      }
      img {
        transform: scale(1.06);
        opacity: 1;
        @media (prefers-reduced-motion) {
          transform: scale(1);
        }
      }
    }

    img {
      transition: 1.2s;
      width: 100%;
      opacity: 0.9;
    }

    .title-1 {
      color: #363748;
    }

    .g-info {
      background: white;
      padding: pxToRem(16);
      border-radius: pxToRem(8);
      margin-top: pxToRem(-8);
      position: relative;
      font-size: pxToRem(18);
      box-shadow: 0px -2px 10px 0px rgba(33, 35, 43, 0.1);
      text-align: left;

      .g-title {
        display: block;
        color: $gskinner-gray-3;
        font-weight: bold;
        font-size: pxToRem(24);
      }

      .g-description {
        display: block;
        color: $gskinner-gray-2;
      }

      a {
        color: $accent;
        display: block;
        margin-top: pxToRem(8);
      }
    }
  }
</style>
